import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
const ComponentCheckbox = ({ id, label, onChange, startChecked = false, classes = '', error = false, hideInput = false }) => {
    const [isChecked, setIsChecked] = useState(startChecked);
    const toggle = () => {
        const newIsChecked = !isChecked;
        setIsChecked(newIsChecked);
        onChange(newIsChecked);
    };
    return (_jsxs("div", Object.assign({ className: 'inline-block relative' }, { children: [error && _jsx("div", Object.assign({ className: 'input-error text-viva-red text-sm mb-2' }, { children: error })), _jsx("input", { id: id, name: id, type: 'checkbox', style: { opacity: hideInput ? '0' : '1' }, checked: isChecked, onChange: () => toggle(), className: 'tailwind-reset mr-1 absolute left-0' }), _jsx("span", { htmlFor: id, className: `tailwind-reset label block -mt-1 ${classes}`, style: { textIndent: '20px' }, role: 'button', tabIndex: 0, onClick: toggle, dangerouslySetInnerHTML: { __html: label } })] })));
};
ComponentCheckbox.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    onChange: PropTypes.func.isRequired,
    startChecked: PropTypes.bool,
    classes: PropTypes.string,
    error: PropTypes.string,
    hideInput: PropTypes.bool
};
export default ComponentCheckbox;
